import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import { VStack } from 'tio-ui/components/layout';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import StrategyFinder0726PlanComparison from 'tio-common/components/strategy-finder-0726/plan-comparison';
import { parseAndFilterResultSections } from 'tio-employee/utils/idr-dashboard-0726';

interface IdrDashboard0726PreviousResultsSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

// The most recent IDR-0726 run shown as a best-vs-current comparison summary on
// the dashboard, with a link to the full results page (mirrors SF-0726).
export default class IdrDashboard0726PreviousResults extends Component<IdrDashboard0726PreviousResultsSignature> {
  get sections() {
    return parseAndFilterResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  <template>
    <VStack ...attributes>
      <StrategyFinder0726PlanComparison
        @recommendation={{@recommendation}}
        @sections={{this.sections}}
        @title={{t "idr_dashboard_0726.previous_results"}}
      />
      <div>
        <LinkTo
          @route="authenticated.idr.dashboard.results"
          @model={{@recommendation.id}}
          class="tio-copy"
        >
          {{t "idr_dashboard_0726.view_full_results"}}
        </LinkTo>
      </div>
    </VStack>
  </template>
}
